/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TitleInputs */

const en_title = /** @type {(inputs: TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title *`)
};

const es_title = /** @type {(inputs: TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título *`)
};

const fr_title = /** @type {(inputs: TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre *`)
};

const de_title = /** @type {(inputs: TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel *`)
};

const ja_title = /** @type {(inputs: TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイトル *`)
};

const zh_title = /** @type {(inputs: TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题 *`)
};

const ar_title = /** @type {(inputs: TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العنوان *`)
};

const id_title = /** @type {(inputs: TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Judul *`)
};

const it_title = /** @type {(inputs: TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titolo *`)
};

const ru_title = /** @type {(inputs: TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название *`)
};

const pt_title = /** @type {(inputs: TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título *`)
};

const ko_title = /** @type {(inputs: TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제목 *`)
};

/**
* | output |
* | --- |
* | "Title *" |
*
* @param {TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const title = /** @type {((inputs?: TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_title(inputs)
	if (locale === "es") return es_title(inputs)
	if (locale === "fr") return fr_title(inputs)
	if (locale === "de") return de_title(inputs)
	if (locale === "ja") return ja_title(inputs)
	if (locale === "zh") return zh_title(inputs)
	if (locale === "ar") return ar_title(inputs)
	if (locale === "id") return id_title(inputs)
	if (locale === "it") return it_title(inputs)
	if (locale === "ru") return ru_title(inputs)
	if (locale === "pt") return pt_title(inputs)
	return ko_title(inputs)
});